import { useRef, useState, useEffect } from 'react';
import { Drawer } from '@navi/web-ui/lib/primitives';
import { EditConfigurationDrawerProps } from '../types';
import ConfigurationForm from '.';
import { useSelector } from 'react-redux';
import type { RootState } from '@cp/src/store';
import LoaderIcon from '@cp/src/assets/icons/LoaderIcon';
import EditConfigurationDrawerFooter from './EditConfigurationDrawerFooter';
import UnsavedChangesFooter from './UnsavedChangesFooter';

const EditConfigurationDrawer = (props: EditConfigurationDrawerProps) => {
  const { isDrawerOpen, onClose, onSuccess, handleQueryCopy } = props;

  const formRef = useRef<any>(null);

  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [isDirtyField, setIsDirtyField] = useState(false);
  const [isOutsideDrawerClick, setIsOutsideDrawerClick] = useState(false);

  const configurationData = useSelector(
    (state: RootState) => state.ciuAllocations.editConfigurationData
  );

  const showLoader = useSelector((state: RootState) => state.ciuAllocations.isDrawerLoading);

  useEffect(() => {
    if (!isDrawerOpen) {
      setIsDirtyField(false);
      setIsOutsideDrawerClick(false);
    }
  }, [isDrawerOpen]);

  const handleSubmitClick = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  const handleClose = () => {
    if (isDirtyField) {
      setIsOutsideDrawerClick(true);
    } else {
      onClose();
    }
  };

  const handleExitYesClick = () => {
    setIsOutsideDrawerClick(false);
    onClose();
  };

  const handleExitNoClick = () => {
    setIsOutsideDrawerClick(false);
  };

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={handleClose}
      headerText="Edit Configuration"
      showHeaderDivider={true}
      contentClasses="overflow-auto"
      className="!w-[400px]"
      onOutSideClick={handleClose}
      footerContainerClasses={
        isOutsideDrawerClick ? '!bg-[var(--navi-color-red-bg)]' : '!pt-2 !px-0'
      }
      footer={
        isOutsideDrawerClick ? (
          <UnsavedChangesFooter
            onConfirmExit={handleExitYesClick}
            onCancelExit={handleExitNoClick}
          />
        ) : (
          <EditConfigurationDrawerFooter
            onClose={onClose}
            onSubmit={handleSubmitClick}
            onQueryCopy={handleQueryCopy}
            isSubmitButtonDisabled={isSubmitButtonDisabled}
            isDirtyField={isDirtyField}
            onCancelClick={handleClose}
          />
        )
      }
    >
      {showLoader ? (
        <div className="absolute h-full w-full bg-white top-0 flex items-center justify-center">
          <LoaderIcon
            size={40}
            borderWidth={4}
            borderColor="var(--navi-color-gray-border)"
            fillColor="var(--navi-color-blue-base)"
          />
        </div>
      ) : (
        <ConfigurationForm
          ref={formRef}
          isDrawerOpen={isDrawerOpen}
          onClose={onClose}
          onSuccess={onSuccess}
          setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
          setIsDirtyField={setIsDirtyField}
          configurationData={configurationData || undefined}
        />
      )}
    </Drawer>
  );
};

export default EditConfigurationDrawer;
